export const ADD_TO_CART = 'ADD_TO_CART'
export const ALTER_SPEC = 'ALTER_SPEC'
export const ALTER_UNIT = 'ALTER_UNIT'
export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE'
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'
export const SET_FOR_CUSTOMER = 'SET_FOR_CUSTOMER'
export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES'
export const REMOVE_FROME_CART = 'REMOVE_FROME_CART'
export const GET_ADDRESSES = 'GET_ADDRESSES'
export const NEW_ADDRESSES = 'NEW_ADDRESSES'
export const EDIT_ADDRESSES = 'EDIT_ADDRESSES'
export const SAVE_ADDRESSES = 'SAVE_ADDRESSES'
export const CLEAR_CART = 'CLEAR_CART'
export const GET_ORDERS = 'GET_ORDERS'
export const ALTER_NUM = 'ALTER_NUM'
export const SET_ORDER_ID = 'SET_ORDER_ID'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js